import { render, staticRenderFns } from "./CategoryManager.vue?vue&type=template&id=6b59a581"
import script from "./CategoryManager.vue?vue&type=script&lang=js"
export * from "./CategoryManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports